/**
 * WARNING!
 * Only components which are sitewide and common should be imported using this method
 * ==================================================================================
 * These standalone components are not 'lazy loaded' but more lazy initiated
 * import { ComponentName } from '/component/path' -> means they are eagerly loaded
 * Any components added to this file will be added to main.js and therefore increase the bundle size
 * To import components lazily please create a module that houses and returns the entry component
 */
import { ComponentType } from '@angular/cdk/overlay'
import { BackToTopComponent } from '@components/exportable/back-to-top/back-to-top.component'
import { FooterComponent } from '@components/exportable/footer/components/footer.component'
import { BrowserUpgradeNoticeComponent } from '@components/exportable/browser-upgrade-notice/browser-upgrade-notice.component'
import { CssFiltersControlComponent } from '@components/exportable/css-filters-control/css-filters-control/css-filters-control.component'
import { HomeButtonComponent } from '@components/exportable/home-button/home-button.component'
import { ToastComponent } from '@components/user-interface/toast/toast.component'

// list of top level lazy loaded standard components
export const lazyLoadedComponents: ComponentType<any>[] = [
  BackToTopComponent,
  BrowserUpgradeNoticeComponent,
  CssFiltersControlComponent,
  FooterComponent,
  HomeButtonComponent,
  ToastComponent,
]
